// extracted by mini-css-extract-plugin
export var smallSpinner = "_q5-0";